import { createFileRoute } from "@tanstack/react-router"
import { UserRoute } from "@/app"

export const Route = createFileRoute("/(user)")({
  ssr: false,
  component: RouteComponent,
})

function RouteComponent() {
  return <UserRoute />
}
